var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSharebenefit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16_share)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.27 59.54C46.4354 59.54 59.54 46.4354 59.54 30.27C59.54 14.1046 46.4354 1 30.27 1C14.1046 1 1 14.1046 1 30.27C1 46.4354 14.1046 59.54 30.27 59.54Z",
    fill: "#FAFBFA",
    fillOpacity: 0.5,
    stroke: "#2E63EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.26 31.63L36.74 38.37M36.74 22.17L26.26 28.9M43.08 42C43.08 45.03 40.61 47.5 37.58 47.5C34.55 47.5 32.08 45.03 32.08 42C32.08 38.97 34.55 36.5 37.58 36.5C40.61 36.5 43.08 38.97 43.08 42ZM43.08 18.53C43.08 21.56 40.61 24.03 37.58 24.03C34.55 24.03 32.08 21.56 32.08 18.53C32.08 15.5 34.55 13.03 37.58 13.03C40.61 13.03 43.08 15.5 43.08 18.53ZM26.26 30.27C26.26 33.3 23.79 35.77 20.76 35.77C17.73 35.77 15.26 33.3 15.26 30.27C15.26 27.24 17.73 24.77 20.76 24.77C23.79 24.77 26.26 27.24 26.26 30.27Z",
    stroke: "#2E63EE",
    strokeWidth: 1.86,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_share"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.53,
    height: 60.53,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharebenefit);
export default __webpack_public_path__ + "static/media/sharebenefit.1251d7abd6bd0dddc5dc7644d07d3748.svg";
export { ForwardRef as ReactComponent };